<template>
  <div>
    <el-alert
      title="仓库可维护库区和库位。有库区或现存量时不可删除。"
      type="info" :closable="false" show-icon style="margin-bottom:12px"
    />
    <div class="toolbar">
      <el-input v-model="query.wareHouseCode" clearable placeholder="仓库编码" style="width:160px" @keyup.enter.native="search" />
      <el-input v-model="query.wareHouseName" clearable placeholder="仓库名称" style="width:160px" @keyup.enter.native="search" />
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新增</el-button>
      <el-button type="danger" plain :disabled="!selection.length" @click="onDelete()">批量删除</el-button>
    </div>
    <el-table :data="list" border v-loading="loading" @selection-change="selection = $event">
      <el-table-column type="selection" width="48" align="center" />
      <el-table-column type="index" label="序号" width="60" align="center" :index="indexMethod" />
      <el-table-column prop="wareHouseCode" label="仓库编码" width="140" />
      <el-table-column prop="wareHouseName" label="仓库名称" min-width="140" show-overflow-tooltip />
      <el-table-column label="类型" width="90" align="center">
        <template slot-scope="{ row }">{{ classLabel(row.wareHouseClass) }}</template>
      </el-table-column>
      <el-table-column prop="chargerName" label="负责人" width="120" show-overflow-tooltip />
      <el-table-column prop="address" label="地址" min-width="160" show-overflow-tooltip />
      <el-table-column label="状态" width="80" align="center">
        <template slot-scope="{ row }">
          <el-tag v-if="row.isenabled === '0'" size="small">启用</el-tag>
          <el-tag v-else size="small" type="info">禁用</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openEdit(row.wareHouseId)">修改</el-button>
          <el-button type="text" @click="openArea(row)">库位</el-button>
          <el-button type="text" style="color:#ef4444" @click="onDelete(row.wareHouseId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="total" :page="page" :page-size="pageSize" :page-sizes="[10, 20, 50, 100]"
      @current-change="onPage" @size-change="onSize"
    />

    <el-dialog :title="form.wareHouseId ? '修改仓库' : '新增仓库'" :visible.sync="visible" width="560px" :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" label-width="90px">
        <el-form-item label="仓库编码" prop="wareHouseCode"><el-input v-model="form.wareHouseCode" /></el-form-item>
        <el-form-item label="仓库名称" prop="wareHouseName"><el-input v-model="form.wareHouseName" /></el-form-item>
        <el-form-item label="仓库类型">
          <el-select v-model="form.wareHouseClass" style="width:100%">
            <el-option label="实体仓" value="0" />
            <el-option label="虚拟仓" value="1" />
            <el-option label="线边仓" value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="负责人">
          <el-select v-model="form.chargerIds" multiple filterable clearable placeholder="请选择负责人" style="width:100%">
            <el-option v-for="u in users" :key="u.id" :label="userLabel(u)" :value="String(u.id)" />
          </el-select>
        </el-form-item>
        <el-form-item label="地址"><el-input v-model="form.address" /></el-form-item>
        <el-form-item label="启用状态">
          <el-switch v-model="form.isenabled" active-value="0" inactive-value="1" />
        </el-form-item>
        <el-form-item label="备注"><el-input v-model="form.remark" type="textarea" :rows="2" /></el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submit">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="'库区/库位 - ' + (areaWh.wareHouseName || '')" :visible.sync="areaVisible" width="780px" :close-on-click-modal="false">
      <div style="margin-bottom:8px">
        <el-button type="primary" size="mini" @click="editArea(null, '0')">新增库区</el-button>
        <el-button size="mini" @click="editArea(null, '1')">新增库位</el-button>
      </div>
      <el-table :data="areaList" border size="small" v-loading="areaLoading">
        <el-table-column prop="wareAreaCode" label="编码" width="120" />
        <el-table-column prop="wareAreaName" label="名称" min-width="140" />
        <el-table-column label="类型" width="80" align="center">
          <template slot-scope="{ row }">{{ row.type === '1' ? '库位' : '库区' }}</template>
        </el-table-column>
        <el-table-column prop="parentName" label="上级库区" width="120" />
        <el-table-column label="操作" width="120" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" size="mini" @click="editArea(row)">改</el-button>
            <el-button type="text" size="mini" @click="removeArea(row.wareAreaId)">删</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog :title="areaForm.wareAreaId ? '修改' : '新增'" :visible.sync="areaFormVisible" width="480px" append-to-body :close-on-click-modal="false">
      <el-form label-width="90px">
        <el-form-item label="类型">
          <el-radio-group v-model="areaForm.type" :disabled="!!areaForm.wareAreaId">
            <el-radio label="0">库区</el-radio>
            <el-radio label="1">库位</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="areaForm.type === '1'" label="所属库区">
          <el-select v-model="areaForm.parentId" filterable style="width:100%">
            <el-option v-for="a in areaZones" :key="a.wareAreaId" :label="a.wareAreaName" :value="a.wareAreaId" />
          </el-select>
        </el-form-item>
        <el-form-item label="编码"><el-input v-model="areaForm.wareAreaCode" /></el-form-item>
        <el-form-item label="名称"><el-input v-model="areaForm.wareAreaName" /></el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="areaFormVisible = false">取消</el-button>
        <el-button type="primary" :loading="areaSaving" @click="saveAreaForm">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import {
  listWareHouse, getWareHouse, saveWareHouse, updateWareHouse, deleteWareHouse,
  listWareArea, saveWareArea, updateWareArea, deleteWareArea
} from '../../api/warehouse'
import { listUsers } from '../../api/sys'

function emptyForm() {
  return {
    wareHouseId: '', wareHouseCode: '', wareHouseName: '', wareHouseClass: '0',
    charger: '', chargerIds: [], address: '', isenabled: '0', remark: '', version: 0
  }
}
function emptyArea(type) {
  return {
    wareAreaId: '', wareHouseId: '', parentId: '', wareAreaCode: '', wareAreaName: '',
    type: type || '0', isenabled: '1'
  }
}

export default {
  components: { ListPagination },
  data() {
    return {
      query: { wareHouseCode: '', wareHouseName: '' },
      list: [], total: 0, page: 1, pageSize: 20, loading: false, saving: false, visible: false,
      selection: [],
      form: emptyForm(),
      users: [],
      rules: {
        wareHouseCode: [{ required: true, message: '仓库编码不能为空', trigger: 'blur' }],
        wareHouseName: [{ required: true, message: '仓库名称不能为空', trigger: 'blur' }]
      },
      areaVisible: false, areaLoading: false, areaSaving: false, areaFormVisible: false,
      areaWh: {}, areaList: [], areaForm: emptyArea()
    }
  },
  computed: {
    areaZones() { return (this.areaList || []).filter(a => a.type === '0') }
  },
  created() {
    this.load()
    listUsers({}).then(res => { this.users = res.data || [] }).catch(() => {})
  },
  methods: {
    classLabel(v) { return { '0': '实体仓', '1': '虚拟仓', '2': '线边仓' }[v] || v },
    userLabel(u) {
      const name = (u.nickname || u.username || '').trim()
      return u.username && name && name !== u.username ? name + ' / ' + u.username : (name || String(u.id))
    },
    splitCharger(value) {
      return String(value || '').split(',').map(s => s.trim()).filter(Boolean)
    },
    indexMethod(i) { return (this.page - 1) * this.pageSize + i + 1 },
    search() { this.page = 1; this.load() },
    onPage(p) { this.page = p; this.load() },
    onSize(s) { this.pageSize = s; this.page = 1; this.load() },
    load() {
      this.loading = true
      listWareHouse({
        currentPage: this.page, pageSize: this.pageSize,
        wareHouseCode: this.query.wareHouseCode, wareHouseName: this.query.wareHouseName
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    openEdit(id) {
      if (!id) {
        this.form = emptyForm()
        this.visible = true
        this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
        return
      }
      getWareHouse(id).then(res => {
        const d = res.data || {}
        this.form = {
          wareHouseId: d.wareHouseId,
          wareHouseCode: d.wareHouseCode,
          wareHouseName: d.wareHouseName,
          wareHouseClass: d.wareHouseClass || '0',
          charger: d.charger || '',
          chargerIds: this.splitCharger(d.charger),
          address: d.address || '',
          isenabled: d.isenabled || '0',
          remark: d.remark || '',
          version: d.version
        }
        this.visible = true
      })
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.saving = true
        const payload = { ...this.form, charger: (this.form.chargerIds || []).join(',') }
        delete payload.chargerIds
        const req = this.form.wareHouseId ? updateWareHouse(payload) : saveWareHouse(payload)
        req.then(() => {
          this.$message.success('操作成功')
          this.visible = false
          this.search()
        }).finally(() => { this.saving = false })
      })
    },
    onDelete(id) {
      const ids = id ? [id] : this.selection.map(i => i.wareHouseId)
      this.$confirm('确定删除选中仓库?', '提示', { type: 'warning' }).then(() => {
        deleteWareHouse(ids).then(() => { this.$message.success('操作成功'); this.load() })
      }).catch(() => {})
    },
    openArea(row) {
      this.areaWh = row
      this.areaVisible = true
      this.loadAreas()
    },
    loadAreas() {
      this.areaLoading = true
      listWareArea({ wareHouseId: this.areaWh.wareHouseId, currentPage: 1, pageSize: 200 }).then(res => {
        this.areaList = (res.data && res.data.list) || []
      }).finally(() => { this.areaLoading = false })
    },
    editArea(row, type) {
      this.areaForm = row ? { ...row } : emptyArea(type)
      this.areaForm.wareHouseId = this.areaWh.wareHouseId
      this.areaFormVisible = true
    },
    saveAreaForm() {
      this.areaSaving = true
      const req = this.areaForm.wareAreaId ? updateWareArea(this.areaForm) : saveWareArea(this.areaForm)
      req.then(() => {
        this.$message.success('保存成功')
        this.areaFormVisible = false
        this.loadAreas()
      }).finally(() => { this.areaSaving = false })
    },
    removeArea(id) {
      this.$confirm('确定删除?', '提示', { type: 'warning' }).then(() => {
        deleteWareArea([id]).then(() => { this.$message.success('已删除'); this.loadAreas() })
      }).catch(() => {})
    }
  }
}
</script>
